import axios from "axios";

import { MAX_ELEMENTS_PER_PAGE } from "../constants/constants.ts";
import { Template } from "../models/Template.ts";

export function useTemplateService() {
  const templateApiUrl = Config.apiBaseUrl + "/templates";
  async function fetchTemplates(page: number, search?: string) {
    const searchParam = search ? `&search=${search}` : "";
    const response = await axios.get(
      `${templateApiUrl}?page=${page}&size=${MAX_ELEMENTS_PER_PAGE}&direction=ASC${searchParam}`
    );
    return response.data;
  }

  async function getTemplateByCode(code: string | undefined) {
    const response = await axios.get(`${templateApiUrl}/${code}`);
    return response.data;
  }

  async function updateTemplate(template: Template) {
    const response = await axios.put(`${templateApiUrl}`, template);
    return response.data;
  }

  return {
    fetchTemplates,
    getTemplateByCode,
    updateTemplate
  };
}
